import {Injectable,} from '@angular/core';
import {SMS011ErrorInVO,} from '@pages/sms011-error/sms011-error-in-vo';
import {MessageStackService,
        WindowService,} from '@services/index';

@Injectable({
  providedIn: 'root',
})
/*****************************************************/
/* 処　理：共通　画面遷移処理
/*
/* 概　要：エラー画面へ遷移
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SmsErrorPage {

  constructor(
    private windowService: WindowService
  ) {
  }

  /**
   * SMS011：エラー画面へ遷移
   *
   * @param msgStack メッセージスタック
   * @param hashId   契約情報ID(ハッシュID）
   * @param menuNo   取引メニュー番号
   * @param lng      言語区分
   *
   */
  transition(msgStack: MessageStackService,
             hashId: string,
             menuNo: string,
             lng:    string ): void {

    // POSTパラメータ設定
    const info011Vo: SMS011ErrorInVO = new SMS011ErrorInVO();
    info011Vo.messageStack = msgStack;
    info011Vo.hashId = hashId;
    info011Vo.menuNo = menuNo;
    info011Vo.languageType = lng;

    // 画面遷移
    this.windowService.transit<SMS011ErrorInVO>('SMS011', info011Vo);
  }
}
